<template>
  <div>
      purchaseOrders 页面
  </div>
</template>
<script>
export default {
    name:'purchaseOrders',
    mounted() {
      this.$store.commit('UPDATE_TITLE', 'purchaseOrders');
    }
};
</script>
<style scoped>
</style>